import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters/getters';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    getters:{
        ...getters,
        getVerificationJwt:(state) =>{
            return state.verificationJwt;
        }
    },
    state: {
        user: false,
        stateTagsList: [
            {
                menuid: 201,
                icon: 'icon-cus-manage',
                menuname: '用户管理',
                hasThird: 'N',
                url: 'system/user',
                menus: null
              }
        ],
        jwt:'',
        verificationJwt:null, //这是用来保存用户等登录验证码jwt身份识别的(令牌这部分参考https://www.cnblogs.com/ztbk/p/11776052.html)
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfo", "");
            state.stateTagsList = [{
                menuid: 201,
                icon: 'icon-cus-manage',
                menuname: '用户管理',
                hasThird: 'N',
                url: 'system/user',
                menus: null
              }];
        },

        /**
         * 选择tag标签
         */
        mutationSelectTags(state, data){
            let result = false
            for(let i=0; i<state.stateTagsList.length;i++){
                if(state.stateTagsList[i].url == data.url){
                    return result = true
                }
            }
            result === false ? state.stateTagsList.push(data) : ''
        },

        /**
         * 关闭tag标签
         */
        mutationCloseTag(state, data){
            let result = state.stateTagsList.findIndex(item => item.url === data.url)
            state.stateTagsList.splice(result, 1)
        },
        setJwt: (state, payload) => {
            state.jwt = payload.jwt;
        },
        setVerificationJwt: (state, payload) => {
            state.verificationJwt = payload.verificationJwt;
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js